import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

import { GET_MY_ROSTER_SHIFTS, GET_MY_UNAVAILABILITIES } from '../../../common/graphql/people/roster';

// After a leave or unavailability change, refresh the requests and the roster shifts shown on
// the roster pages that are still open underneath (any month the calendar has loaded).
const useRefetchMyRosterEntries = () => {
	const client = useApolloClient();

	return useCallback(() => client.refetchQueries({
		include: [GET_MY_UNAVAILABILITIES, GET_MY_ROSTER_SHIFTS],
	}), [client]);
};

export default useRefetchMyRosterEntries;
